export const MAX_PHOTO_BYTES = 20 * 1024 * 1024
export const MAX_PHOTO_PIXELS = 50_000_000
export const PHOTO_MIME_TYPES: readonly string[] = ["image/jpeg", "image/png", "image/webp"]
export const MIN_SIMILARITY = 0.55
export const RESULTS_PER_PAGE = 12
